import React from 'react';
import { Testimonials } from '../Testimonials';
import { CTA } from '../CTA';
export const TestimonialsPage = () => {
  return <div className="w-full bg-white" data-id="element-408">
      <Testimonials data-id="element-409" />
      <CTA data-id="element-410" />
    </div>;
};